import { PageConfigService } from 'src/app/page-config.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserApiService } from 'src/app/user-api.service';
import { ServiceInfo } from 'src/app/models/display/serviceInfo';
import { UserApi } from 'src/app/models/api_models/user';
import { AutorizationService } from 'src/app/api/autorization.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav-auth-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss']
})
export class SidenavContentComponent implements OnInit {
  _servicesList : ServiceInfo[] = [];
  _currentUser : any;
  isUserLoad : boolean = false;
  constructor( private PageConfigService: PageConfigService, public translate: TranslateService, private cookieService: CookieService, private userApiService : UserApiService, private oauthService : AutorizationService, private router: Router) 
  { 
     // translate
     translate.addLangs(['fr', 'en', 'es']);
     translate.setDefaultLang('fr');
 
     const browserLang = translate.getBrowserLang();
     translate.use(browserLang.match(/fr|en|es|ca/) ? browserLang : 'fr');

     this.PageConfigService.config.subscribe((x) =>{this.urlInform = x.inform_link})

     this.site = this.getSite();
  }


  site: string;

  locales = [
    { label: '🇫🇷', value: 'fr' },
    { label: '🇺🇸', value: 'en' },
    { label: '🇪🇸', value: 'es' },
    { label: 'ca', value: 'ca' },
  ];

  urlInform: any 
  community: any
  urlCovoiturage = `${location.origin}/covoiturage`


  @Output() close = new EventEmitter<boolean>();


  disconnect() {
    localStorage.removeItem('token_clem_mobi')
    localStorage.removeItem('token_offline')
    this.oauthService.logout();
    this.router.navigate(['/']).then(ok => {
      window.location.reload();
    });
  }

  CloseAction() {
    this.close.emit(true);
  }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._currentUser = response;
         console.log(this._currentUser);
        //  this.urlInform = this._currentUser?.community?.id !== 153 ? `${this._currentUser?.link_to_inform_page}` :  this._currentUser?.link_to_inform_page === null ? `https://subscribe.clem.mobi/inform`  :  `https://subscribe.clem.mobi/inform`
          this.isUserLoad = true;
          this._servicesList = this._currentUser.getUserServices();
        }
      },
      error => {
        // console.log(error);
        
      }
    );
  }



   getSite(): string {
  const host = location.host;

  switch (host) {
    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      return 'mam';

    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
      return 'remi';

    default:
      return 'default';
  }

  
}


  



}
